/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { components } from '@/ts/api/core/schema.generated.ts'

import { Entity } from '@/ts/entities/base/entity.ts'
import { Identifier } from '@/ts/entities/base/identifier.ts'

export type APIDepartment = components['schemas']['Department']

export class Department extends Entity<APIDepartment> {
  constructor(
    id: Identifier,
    public name: string,
    public abbrev: string,
    public schedulingPeriodUnit: components['schemas']['SchedulingPeriodUnitEnum'],
    public schedulingPeriodSpan: number
  ) {
    super(id)
  }

  toJSON() {
    return {
      id: this.id,
      name: this.name,
      abbrev: this.abbrev,
      scheduling_period_unit: this.schedulingPeriodUnit,
      scheduling_period_span: this.schedulingPeriodSpan,
    }
  }

  static fromJSON(department: APIDepartment): Department {
    return new Department(
      new Identifier(department.id),
      department.name,
      department.abbrev,
      department.scheduling_period_unit,
      department.scheduling_period_span
    )
  }
}
